import {useCallback, useEffect} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {updateAxiosHandlers} from '@kcast-fe/core';
import {useNavigate} from 'react-router';
import {useAuthStore} from 'stores';
import {BaseLayout} from 'ui-kit';
import {ROUTES, UserManager} from 'core';

import {AppAuth} from './App.Auth';
import {AppRouter} from './App.Router';

const App = () => {
  const {actions: authActions} = useAuthStore(useShallow((state) => state));

  const navigate = useNavigate();

  const tryToSignIn = useCallback(() => {
    UserManager.getUser().then((user) => {
      if (user?.expired) {
        UserManager.signinSilent().then((newUser) => {
          if (!newUser) {
            authActions.signOut().then();
          } else {
            console.info('[Auth] User expired, refreshed.');
          }
        });
      }
    });
  }, [authActions]);

  useEffect(() => {
    updateAxiosHandlers(
      () => tryToSignIn(), // 401
      () => {}, // 404
      () => navigate(ROUTES.System.Error503) // 503
    );
  }, [navigate, tryToSignIn, authActions]);

  useEffect(() => {
    authActions.loadUser().then();
  }, [authActions]);

  return (
    <AppAuth>
      <BaseLayout>
        <AppRouter />
      </BaseLayout>
    </AppAuth>
  );
};

export default App;
